var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialerCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#4F772D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.985 45.8847C52.7621 47.5785 51.9303 49.1333 50.6449 50.2586C49.3595 51.3839 47.7084 52.0028 46 51.9997C36.075 51.9997 28 43.9247 28 33.9997C27.9969 32.2914 28.6159 30.6403 29.7412 29.3549C30.8665 28.0695 32.4212 27.2376 34.115 27.0147C34.5433 26.9624 34.9771 27.0501 35.3515 27.2645C35.7259 27.479 36.0209 27.8088 36.1925 28.2047L38.8325 34.0985V34.1135C38.9639 34.4166 39.0181 34.7474 38.9904 35.0766C38.9627 35.4057 38.8539 35.7229 38.6738 35.9997C38.6513 36.0335 38.6275 36.0647 38.6025 36.096L36 39.181C36.9363 41.0835 38.9263 43.056 40.8538 43.9947L43.8963 41.406C43.9261 41.3809 43.9574 41.3575 43.99 41.336C44.2666 41.1515 44.5849 41.0389 44.916 41.0083C45.2471 40.9778 45.5806 41.0302 45.8863 41.161L45.9025 41.1685L51.7913 43.8072C52.1879 43.9782 52.5185 44.273 52.7337 44.6474C52.9489 45.0219 53.037 45.456 52.985 45.8847Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialerCall);
export default __webpack_public_path__ + "static/media/DialerCall.d6849e306c324af6b888d8ec7612778f.svg";
export { ForwardRef as ReactComponent };